import React from "react";
import styled from "styled-components";
import InstagramIcon from "../images/social-icons/instagram.png";
import TwitterIcon from "../images/social-icons/twitter.png";

const SocialsHeaderWrapper = styled.div`
  background-color: black;
  height: 35px;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  align-items: flex-end;
  width: 100%;
  bottom: 0;
  z-index: 2;
  position: absolute;
  overflow: hidden;
  @media (max-width: 768px) {
      padding: 16px;
    
    }
`;

const SocialsList = styled.ul`
height: 100%;
    display: flex;
    list-style-type: none;
    margin: 0;
    padding-right: 16px;
    
    @media (max-width: 768px) {
      padding-right: 36px;
    }

`

const SocialLi = styled.li`
    margin: 0 10px;
    display: flex;
    justify-content: center;
    align-items: center;
`

const SocialA = styled.img`
 width: 24px;

@media (max-width: 768px) {
  width: 26px;
}
`
const SocialsHeader = () => {
  return (
    <SocialsHeaderWrapper>
        <SocialsList>
            <SocialLi>
                <a style={{display: 'flex'}} href="https://www.instagram.com/springtreesolutions/" rel="noreferrer" target="_blank"><SocialA alt="instagram" src={InstagramIcon} /></a>
            </SocialLi>
            <SocialLi>
                <a  style={{display: 'flex'}} href="https://twitter.com/springtreenews" rel="noreferrer" target="_blank"><SocialA alt="twitter" src={TwitterIcon} /></a>
            </SocialLi>
        </SocialsList>
    </SocialsHeaderWrapper>
  );
};

export default SocialsHeader;
